export const HEADER_CREATE_GROUP_BUTTON = 'header-create-group-button';
